import posthog from 'posthog-js'

const BENIGN_ERROR_PATTERNS = [
    /NavigationDuplicated/i,
    /Avoided redundant navigation/i,
    /Redirected when going from/i,
    /Navigation cancelled from/i,
    /Navigation aborted from/i,
    /hasAttribute is not a function/i,
    /AbortError: The user aborted a request/i,
    /Request aborted/i,
]

function isBenign(errorMessage) {
    if (!errorMessage) return false
    return BENIGN_ERROR_PATTERNS.some((re) => re.test(errorMessage))
}

export default {
    install(Vue) {
        posthog.init(process.env.VUE_APP_POSTHOG_KEY, {
            api_host: 'https://eu.i.posthog.com',
            defaults: '2025-05-24',
            before_send: (event) => {
                if (!event) {
                    return event;
                }
                if (event.event === '$exception') {
                    const props = event.properties || {}
                    const list = props.$exception_list || []
                    const firstMessage = (list[0] && (list[0].value || list[0].message)) || props.$exception_message || ''
                    if (isBenign(firstMessage)) {
                        return null;
                    }
                }
                return event
            },
        })

        Vue.prototype.$posthog = posthog
    },
}
